export const colors = {
  black: '#000000',
  white: '#FFFFFF',
  grey: {
    '25': '#F7F7F7',
    '50': '#F0F0F0',
    '100': '#E6E6E6',
    '200': '#CCCCCC',
    '300': '#B3B3B3',
    '400': '#999999',
    '500': '#808080',
    '600': '#666666',
    '700': '#4D4D4D',
    '800': '#333333',
    '900': '#1F1F1F',
    '950': '#0F0F0F',
  },
  gray: {
    '25': '#F7F7F7',
    '50': '#F0F0F0',
    '100': '#E6E6E6',
    '200': '#CCCCCC',
    '300': '#B3B3B3',
    '400': '#999999',
    '500': '#808080',
    '600': '#666666',
    '700': '#4D4D4D',
    '800': '#333333',
    '900': '#1F1F1F',
    '950': '#0F0F0F',
  },
  blue: {
    '25': '#F2F6FF',
    '50': '#E0EAFF',
    '100': '#CCDCFF',
    '200': '#B8CEFF',
    '300': '#7DA9FF',
    '400': '#4580FF',
    '500': '#0050FF',
    '600': '#0041D9',
    '700': '#003AC5',
    '800': '#001647',
    '900': '#001033',
    '950': '#000D29',
  },
  green: {
    '25': '#F3FCF4',
    '50': '#E1F8E4',
    '100': '#CEF3D1',
    '200': '#BAEEBF',
    '300': '#74E971',
    '400': '#4CDC4B',
    '500': '#08C21A',
    '600': '#00A410',
    '700': '#008D0C',
    '800': '#023607',
    '900': '#022705',
    '950': '#011F04',
  },
  red: {
    '25': '#FEF5F4',
    '50': '#FDE6E4',
    '100': '#FBD5D1',
    '200': '#FAC5BF',
    '300': '#FF9A89',
    '400': '#FF745F',
    '500': '#ED2F1A',
    '600': '#CB1C08',
    '700': '#B31A09',
    '800': '#420D07',
    '900': '#2F0905',
    '950': '#260804',
  },
  orange: {
    '25': '#FFF9F3',
    '50': '#FEF1E3',
    '100': '#FEE7D0',
    '200': '#FEDDBD',
    '300': '#FFC094',
    '400': '#FFAB6D',
    '500': '#FA8714',
    '600': '#D57000',
    '700': '#B75F00',
    '800': '#462606',
    '900': '#321B04',
    '950': '#281603',
  },
  gold: {
    '25': '#FEFCF8',
    '50': '#FDF8EE',
    '100': '#FBF3E3',
    '200': '#F9EED7',
    '300': '#FAD897',
    '400': '#F2CE88',
    '500': '#EBC271',
    '600': '#DDAD45',
    '700': '#BB9035',
    '800': '#423620',
    '900': '#2F2717',
    '950': '#261F12',
  },
  purple: {
    '25': '#F9F3FF',
    '50': '#F1E1FF',
    '100': '#E7CDFE',
    '200': '#DEB9FE',
    '300': '#B897FF',
    '400': '#A572FF',
    '500': '#8906FC',
    '600': '#7300D6',
    '700': '#6700C1',
    '800': '#260247',
    '900': '#1B0132',
    '950': '#160128',
  },
  // Deprecated: keep for backward compatibility only.
  pink: {
    '50': '#FEEBEF',
    '100': '#FED8DF',
    '200': '#FCB0BE',
    '300': '#FB899E',
    '400': '#F9617D',
    '500': '#F83A5C',
    '600': '#F71C45',
    '700': '#EC0832',
    '800': '#CF072C',
    '900': '#B10626',
  },
  blackAlpha: {
    '25': 'rgba(0, 0, 0, 0.04)',
    '50': 'rgba(0, 0, 0, 0.06)',
    '100': 'rgba(0, 0, 0, 0.12)',
    '200': 'rgba(0, 0, 0, 0.18)',
    '300': 'rgba(0, 0, 0, 0.30)',
    '400': 'rgba(0, 0, 0, 0.40)',
    '500': 'rgba(0, 0, 0, 0.50)',
    '600': 'rgba(0, 0, 0, 0.60)',
    '700': 'rgba(0, 0, 0, 0.70)',
    '800': 'rgba(0, 0, 0, 0.80)',
    '900': 'rgba(0, 0, 0, 0.88)',
    '950': 'rgba(0, 0, 0, 0.92)',
  },
  whiteAlpha: {
    '25': 'rgba(255, 255, 255, 0.04)',
    '50': 'rgba(255, 255, 255, 0.06)',
    '100': 'rgba(255, 255, 255, 0.12)',
    '200': 'rgba(255, 255, 255, 0.18)',
    '300': 'rgba(255, 255, 255, 0.30)',
    '400': 'rgba(255, 255, 255, 0.40)',
    '500': 'rgba(255, 255, 255, 0.50)',
    '600': 'rgba(255, 255, 255, 0.60)',
    '700': 'rgba(255, 255, 255, 0.70)',
    '800': 'rgba(255, 255, 255, 0.80)',
    '900': 'rgba(255, 255, 255, 0.88)',
    '950': 'rgba(255, 255, 255, 0.92)',
  },
};
